module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', {
    directives: [{
      name: "min-height",
      rawName: "v-min-height"
    }]
  }, [_c('c-page', [_c('c-content', [_c('div', {
    staticClass: "alpha-register"
  }, [_c('div', {
    staticClass: "header bg-img"
  }, [_c('div', {
    staticClass: "header-desc"
  }, [_c('img', {
    staticClass: "alpha-logo",
    attrs: {
      "src": require("../../assets/images/logo/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-desc"
  }, [_vm._v("欢迎注册生意专家")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "register-form"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "s-form-group"
  }, [_c('i', {
    staticClass: "s-icon s-icon-store prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.storeName),
      expression: "formItem.storeName"
    }],
    staticClass: "prepend-icon",
    attrs: {
      "type": "text",
      "placeholder": "店铺名称（8个字以内）"
    },
    domProps: {
      "value": (_vm.formItem.storeName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.formItem.storeName = $event.target.value
      }, function($event) {
        _vm.validName = false
      }],
      "blur": function($event) {
        _vm.validateName()
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validName),
      expression: "validName"
    }],
    staticClass: "s-icon s-icon-check-circle-italic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-form-group"
  }, [_c('i', {
    staticClass: "s-icon s-icon-telephone prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.telephoneNum),
      expression: "formItem.telephoneNum"
    }],
    staticClass: "prepend-icon",
    attrs: {
      "type": "phone",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.formItem.telephoneNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.formItem.telephoneNum = $event.target.value
      }, function($event) {
        _vm.validPhone = false
      }],
      "blur": function($event) {
        _vm.validatePhone()
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validPhone),
      expression: "validPhone"
    }],
    staticClass: "s-icon s-icon-check-circle-italic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-form-group"
  }, [_c('i', {
    staticClass: "s-icon s-icon-password prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.passwordNum),
      expression: "formItem.passwordNum"
    }],
    staticClass: "prepend-icon",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.formItem.passwordNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.formItem.passwordNum = $event.target.value
      }, function($event) {
        _vm.validPass = false
      }],
      "blur": function($event) {
        _vm.validatePass()
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validPass),
      expression: "validPass"
    }],
    staticClass: "s-icon s-icon-check-circle-italic"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "s-btn s-btn--orange",
    on: {
      "click": function($event) {
        _vm.nextStep()
      }
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('p', {
    staticClass: "mt-20 text-center text-color gray"
  }, [_vm._v("点击下一步，即同意 "), _c('a', {
    staticClass: "text-color orange",
    on: {
      "click": function($event) {
        _vm.goUserTerm()
      }
    }
  }, [_vm._v("《生意专家用户协议》")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-container"
  }, [_c('info-footer')], 1)])])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e7b467d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/alpha-sign-up/index.vue
// module id = 371
// module chunks = 0